import { tradingSteps } from '@/mocks/home';
import ScrollReveal from '@/components/base/ScrollReveal';
import SectionHeading from '@/components/base/SectionHeading';

export default function TradingSteps() {
  return (
    <section className="border-y border-background-200 bg-background-100/60">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20 lg:px-10">
        <SectionHeading
          eyebrow="กระบวนการเทรด"
          title="วิธีเทรด Forex สำหรับมือใหม่"
          subtitle="ทำตามลำดับขั้นตอนอย่างเป็นระบบ ตั้งแต่เลือกตลาดจนถึงปิดออเดอร์"
        />

        <div className="mt-12 grid grid-cols-1 gap-x-10 gap-y-2 md:grid-cols-2 lg:grid-cols-3">
          {tradingSteps.map((step, index) => (
            <ScrollReveal key={step.no} delay={index * 60} className="h-full">
              <div className="group relative -mx-3 h-full rounded-lg border-t border-background-300 px-3 py-7 transition-colors duration-300 hover:bg-background-50">
                <span className="absolute left-3 top-[-1px] h-[2px] w-0 bg-accent-500 transition-all duration-500 ease-out group-hover:w-[calc(100%-1.5rem)]" />
                <div className="flex gap-5">
                  <span
                    className={`font-num text-4xl font-semibold leading-none transition-transform duration-300 ease-out md:text-5xl group-hover:-translate-y-1 ${
                      step.accent ? 'text-accent-600' : 'text-primary-600'
                    }`}
                  >
                    {step.no}
                  </span>
                  <div className="pt-1">
                    <h3 className="font-heading text-base font-semibold text-foreground-950 transition-colors duration-300 group-hover:text-primary-700 md:text-lg">
                      {step.title}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
                  </div>
                </div>
                <i
                  aria-hidden="true"
                  className="ri-arrow-right-line pointer-events-none absolute right-2 top-7 -translate-x-2 text-lg text-accent-600 opacity-0 transition-all duration-300 ease-out group-hover:translate-x-0 group-hover:opacity-100"
                />
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}